// IMPORTANT: Initialize Sentry before any other imports
import './sentry';

import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n'; // Initialize i18n before rendering
import { isGamMockEnabled, installGamMock } from './dev/gamMock';

// `?gamMock=1`: stand in for Google's ad server, which never fills on localhost or for
// a UK IP. Must install before anything queues GPT work; index.html skips the real
// gpt.js under the same flag so the two never fight over window.googletag.
if (isGamMockEnabled()) {
  installGamMock();
}

// Environment Configuration Logging
const API_URL =
  import.meta.env.VITE_API_URL || import.meta.env.VITE_PREPLAY_API_URL || 'http://localhost:3001';
const isLocalBackend = API_URL.includes('localhost');
const isAzureBackend = API_URL.includes('azurewebsites.net');

// Determine which .env file is active based on the API URL
let activeEnvFile = '.env (default)';
if (import.meta.env.MODE === 'development') {
  if (isLocalBackend) {
    activeEnvFile = '.env.development.local (localhost override)';
  } else if (isAzureBackend) {
    activeEnvFile = '.env.development (Azure)';
  } else {
    activeEnvFile = '.env.development';
  }
} else if (import.meta.env.MODE === 'production') {
  activeEnvFile = '.env.production';
}

// Simplified environment logging - technical users can inspect via browser devtools
if (import.meta.env.DEV) {
  console.log(`[Frontend] ${import.meta.env.MODE} mode | API: ${API_URL}`);
}

createRoot(document.getElementById('root')!).render(<App />);
